import { render, staticRenderFns } from "./KeywordShortCut.vue?vue&type=template&id=07713074"
import script from "./KeywordShortCut.vue?vue&type=script&lang=js"
export * from "./KeywordShortCut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports